// ДАТА ДОКУМЕНТА = ДАТА ГЕНЕРАЦИИ (решение Кирилла 21.08; спека §I `first_reading_badge` /
// `recorded_date`: «{DD · MM · YYYY}», пустыми не бывают). Штампуется один раз, печатной дорогой
// (обложка и документ шага 7, экспорт) — не рендерером: фикстуры, борды и отпечаток документа
// остаются детерминированными, а печать получает сегодняшний день. Механики устаревания нет.

/** Сегодня по МЕСТНОМУ времени читателя, `YYYY-MM-DD` (не UTC: за полночь UTC дата уехала бы). */
export function localIsoDate(d = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** `YYYY-MM-DD` → «DD · MM · YYYY» — формат спеки §I и подвала §III. */
export function fmtDocDate(iso) {
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d} · ${m} · ${y}`;
}
